import styled from "styled-components";

export const AreaButton = styled.div`
	position: sticky;
	display: flex;
	top: 4rem;
	margin: -5rem 0 1rem auto;
	z-index: 10;
	gap: 1rem;

	> button {
		margin: 1rem 0;
	}

	@media (max-width: 560px) {
		margin: 0 0 1rem auto;
		> button {
			padding: 0px 3px;
		}
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;
